import { useState } from "react";

export const useTaskAddState = () => {
  const [alertVariant, setAlertVariant] = useState("danger");
  const [allUsers, setAllUsers] = useState<any[]>();
  const [allTaskTypes, setAllTaskTypes] = useState<any[]>();
  const [visibleRecurring, setVisibleRecurring] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState<any>({});
  const [taskTemplate, setTaskTemplate] = useState<any>({});
  const [adminEmail, setAdminEmail] = useState("");
  const [taskTypeId, setTaskTypeId] = useState("");
  const [taskTypeRecord, setTaskTypeRecord] = useState<any>({});
  const [allTaskTypesFull, setAllTaskTypesFull] = useState<any[]>();
  const [dataReady, setDataReady] = useState(false);

  return {
    alertVariant,
    setAlertVariant,
    allUsers,
    setAllUsers,
    allTaskTypes,
    setAllTaskTypes,
    visibleRecurring,
    setVisibleRecurring,
    emailTemplate,
    setEmailTemplate,
    taskTemplate,
    setTaskTemplate,
    adminEmail,
    setAdminEmail,
    taskTypeId,
    setTaskTypeId,
    taskTypeRecord,
    setTaskTypeRecord,
    allTaskTypesFull,
    setAllTaskTypesFull,
    dataReady,
    setDataReady,
  };
};
